import { cn } from '@lib/utils';
import React from 'react';

type SectionCardProps = {
  children: React.ReactNode;
  className?: string;
};

export const SectionCard: React.FC<SectionCardProps> = (props) => {
  const { children, className } = props;

  return (
    <div className={cn('group relative rounded-lg border border-gray-200 bg-white p-4', className)}>{children}</div>
  );
};
